import { BrowserRouter as Router,Routes,Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Coins from "./components/Coins";
import Exchanges from "./components/exchanges";
import CoinDetails from "./components/CoinDetails";
import Footer from  "./components/Footer"


function App() {
  return(
    <Router>
      <Header/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Coins" element={<Coins />} />
        <Route path="/exchanges" element={<Exchanges />} />
        <Route path="/Coin/:id" element={<CoinDetails />} />
      </Routes>

      <Footer />
    </Router>
  )
}

export default App;
